import React, { useState } from "react";
import strains from "../../local_data/strains";

import {
  Form,
  Input,
  Modal,
  Button,
  Select,
  Steps,
  Typography,
  Rate,
  message,
  Slider,
} from "antd";
import { FrownOutlined, MehOutlined, SmileOutlined } from "@ant-design/icons";
import consumption_types from "../../local_data/consumption_types";

interface RatingsProps {
  index: number;
}

const {TextArea} = Input;

const customIcons = [
  <FrownOutlined />,
  <FrownOutlined />,
  <FrownOutlined />,
  <MehOutlined />,
  <MehOutlined />,
  <MehOutlined />,
  <SmileOutlined />,
  <SmileOutlined />,
  <SmileOutlined />,
];

const initialValues = {
  product_entry_id: "",
  consumption_type_id: "",
  user_id: "",
  user_description: "",
  user_rating: "",
  rating_1_before: "0",
  rating_2_before: "0",
  rating_3_before: "0",
  rating_4_before: "0",
  rating_5_before: "0",
  rating_6_before: "0",
  rating_7_before: "0",
  rating_8_before: "0",
  rating_9_before: "0",
  rating_10_before: "0",
  rating_1_after: "0",
  rating_2_after: "0",
  rating_3_after: "0",
  rating_4_after: "0",
  rating_5_after: "0",
  rating_6_after: "0",
  rating_7_after: "0",
  rating_8_after: "0",
  rating_9_after: "0",
  rating_10_after: "0",
  rating_1_question_id: "q-1",
  rating_2_question_id: "q-2",
  rating_3_question_id: "q-3",
  rating_4_question_id: "q-4",
  rating_5_question_id: "q-5",
  rating_6_question_id: "q-6",
  rating_7_question_id: "q-7",
  rating_8_question_id: "q-8",
  rating_9_question_id: "q-9",
  rating_10_question_id: "q-10",
};

interface Values {
  product_entry_id: string,
  consumption_type_id: string,
  user_id: string
  user_rating: string
  user_description: string
  rating_1_before: string,
  rating_2_before: string,
  rating_3_before: string,
  rating_4_before: string,
  rating_5_before: string,
  rating_6_before: string,
  rating_7_before: string,
  rating_8_before: string,
  rating_9_before: string,
  rating_10_before: string,
  rating_1_after: string,
  rating_2_after: string,
  rating_3_after: string,
  rating_4_after: string,
  rating_5_after: string,
  rating_6_after: string,
  rating_7_after: string,
  rating_8_after: string,
  rating_9_after: string,
  rating_10_after: string,
  rating_1_question_id: string,
  rating_2_question_id: string,
  rating_3_question_id: string,
  rating_4_question_id: string,
  rating_5_question_id: string,
  rating_6_question_id: string,
  rating_7_question_id: string,
  rating_8_question_id: string,
  rating_9_question_id: string,
  rating_10_question_id: string,
}

interface EntrySubmissionFormProps {
  id: string;
  visible: boolean;
  product: any;
  onCreate: (values: Values) => void;
  onCancel: () => void;
}

export const EntrySubmissionModal: React.FC<EntrySubmissionFormProps> = ({
  id,
  visible,
  product,
  onCreate,
  onCancel,
}) => {
  initialValues.user_id = id;
  const [form] = Form.useForm();
  const [current, setCurrent] = useState(0);

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const { Step } = Steps;

  const steps = [
    {
      title: "Before",
    },
    {
      title: "After",
    },
    {
      title: "Description",
    },
  ];

  return (
    <Modal
      visible={visible}
      title="Post a new Entry"
      okText="Create"
      cancelText="Cancel"
      onCancel={onCancel}
      footer={null}
    >
      <Steps current={current} direction="vertical">
        {steps.map((item) => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>
      <Form
        form={form}
        layout="vertical"
        name="form_in_modal"
        initialValues={initialValues}
      >
        {" "}
        <div style={{ display: current === 0 ? "block" : "none" }}>
          <br />
          <Typography.Title level={4}>Consumption Type:</Typography.Title>
          <Form.Item
            name="consumption_type_id" 
            rules={[
                { 
                  required: true,
                  message: "Please put in the consumption type" 
                },
            ]}
          >
            <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Select Consumption Type"
              optionFilterProp="children"
              filterOption={(input, option) => {
                return (
                  option?.children
                    ?.toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                );
              }}
              filterSort={(optionA, optionB) => {
                return optionA?.children
                  ?.toString()
                  .toLowerCase()
                  .localeCompare(optionB?.children?.toLowerCase());
              }}
            >
              {consumption_types?.map((data) => {
                return (
                  <Select.Option
                    key={data.consumption_name_en}
                    value={data.consumption_id}
                  >
                    {data.consumption_name_en}
                  </Select.Option>
                );
              })}
              ;
            </Select>
          </Form.Item>
          <Typography.Title level={4}>Before Use:</Typography.Title>
          <Form.Item name="rating_1_before" label="Sad (-5)   /   Happy (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
          <Form.Item name="rating_2_before" label="Couchlock (-5)   /   Energetic (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
          <Form.Item name="rating_3_before" label="Anxious (-5)   /   Mellow (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
          <Form.Item name="rating_4_before" label="Unfocused (-5)   /   Focused (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
          <Form.Item name="rating_5_before" label="High Pain (-5)   /   Low Pain (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
          <Form.Item name="rating_6_before" label="Uninspired (-5)   /   Creative (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
          <Form.Item name="rating_7_before" label="Tired (-5)   /   Alert (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
          <Form.Item name="rating_8_before" label="Antisocial (-5)   /   Social (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
          <Form.Item name="rating_9_before" label="Nausea (-5)   /   No Nausea (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
          <Form.Item name="rating_10_before" label="Psychedelic (-5)   /   Sober (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
        </div>
        <div style={{ display: current === 1 ? "block" : "none" }}>
          <br />
          <Typography.Title level={5}>Wait 5-10 min to feel the affects</Typography.Title>
          <br />
          <Typography.Title level={4}>After Use:</Typography.Title>
          <Form.Item name="rating_1_after" label="Sad (-5) / Happy (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
          <Form.Item name="rating_2_after" label="Couchlock (-5) / Energetic (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
          <Form.Item name="rating_3_after" label="Anxious (-5) / Mellow (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
          <Form.Item name="rating_4_after" label="Unfocused (-5) / Focused (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
          <Form.Item name="rating_5_after" label="High Pain (-5) / Low Pain (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
          <Form.Item name="rating_6_after" label="Uninspired (-5)   /   Creative (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
          <Form.Item name="rating_7_after" label="Tired (-5)   /   Alert (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
          <Form.Item name="rating_8_after" label="Antisocial (-5)   /   Social (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
          <Form.Item name="rating_9_after" label="Nausea (-5)   /   No Nausea (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
          <Form.Item name="rating_10_after" label="Psychedelic (-5)   /   Sober (5)">
            <Slider defaultValue={0} max={5} min={-5} />
          </Form.Item>
        </div>
        <div style={{ display: current === 2 ? "block" : "none" }}>
          <br />  
          <br />  
          <br />     
          <Form.Item name="user_description" label="Consumption Description">
              <TextArea autoSize={{ minRows: 4, maxRows: 8 }}/>
          </Form.Item>
          <Form.Item name="user_rating" label="Consumption Rating">
             <Rate allowHalf defaultValue={2.5} />
          </Form.Item>
          <br />  
          <br />  
          <br />  
        </div>
        <div className="steps-action">
          {current < steps.length - 1 && (
            <Button type="primary" onClick={() => {
              return form
              .validateFields()
              .then(() => next())}}>
              Next
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button
              type="primary"
              onClick={() => {
                form
                  .validateFields()
                  .then((values) => {
                    const newValues = values;
                    newValues.product_entry_id = product;
                    newValues.rating_1_before = values?.rating_1_before?.toString();
                    newValues.rating_2_before = values?.rating_2_before?.toString();
                    newValues.rating_3_before = values?.rating_3_before?.toString();
                    newValues.rating_4_before = values?.rating_4_before?.toString();
                    newValues.rating_5_before = values?.rating_5_before?.toString();
                    newValues.rating_6_before = values?.rating_6_before?.toString();
                    newValues.rating_7_before = values?.rating_7_before?.toString();
                    newValues.rating_8_before = values?.rating_8_before?.toString();
                    newValues.rating_9_before = values?.rating_9_before?.toString();
                    newValues.rating_10_before = values?.rating_10_before?.toString();
                    newValues.rating_1_after = values?.rating_1_after?.toString();
                    newValues.rating_2_after = values?.rating_2_after?.toString();
                    newValues.rating_3_after = values?.rating_3_after?.toString();
                    newValues.rating_4_after = values?.rating_4_after?.toString();
                    newValues.rating_5_after = values?.rating_5_after?.toString();
                    newValues.rating_6_after = values?.rating_6_after?.toString();
                    newValues.rating_7_after = values?.rating_7_after?.toString();
                    newValues.rating_8_after = values?.rating_8_after?.toString();
                    newValues.rating_9_after = values?.rating_9_after?.toString();
                    newValues.rating_10_after = values?.rating_10_after?.toString();
                    newValues.user_rating = values?.user_rating?.toString();
                    newValues.rating_1_question_id = "q-1";
                    newValues.rating_2_question_id = "q-2";
                    newValues.rating_3_question_id = "q-3";
                    newValues.rating_4_question_id = "q-4";
                    newValues.rating_5_question_id = "q-5";
                    console.log(values);
                    console.log(newValues);
                    form.resetFields();
                    onCreate(values);
                  })
                  .catch((info) => {
                    console.log("Validate Failed:", info);
                  });
                message.success("Entry Submitted!");
              }}
            >
              Done
            </Button>
          )}
          {current > 0 && (
            <Button style={{ margin: "0 8px" }} onClick={() => prev()}>
              Previous
            </Button>
          )}
        </div>
      </Form>
    </Modal>
  );
};
